import reactComponentLoader from 'scripts/react-component-loader'

import Reviews from './Reviews'
import ReviewPopover from './ReviewPopover'

reactComponentLoader(Reviews, '[data-pdp-reviews]')
reactComponentLoader(ReviewPopover, '[data-pdp-review-popover]')
